import { render } from "./pb-news.vue?vue&type=template&id=dfc48782"
import script from "./pb-news.vue?vue&type=script&lang=js"
export * from "./pb-news.vue?vue&type=script&lang=js"

import "./pb-news.vue?vue&type=style&index=0&id=dfc48782&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__